import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return null; // or a loading spinner
  }

  // If user is authenticated, redirect to app
  return user ? <Navigate to="/app/tasks" replace /> : children;
};

export default PublicRoute;

